import styled from 'styled-components';

export default styled.div`
  > .container {
    position: relative;

    > .device {
      position: absolute;
    }
  }
`;
